let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("dH2J7"), load("iQ0Jm"), load("ffEVr"), load("krOJz")]).then(() => parcelRequire('lMhQj'));